// Module
var code = `<div class="form-column">
  <form-section form-title="'Advanced'">
    <form-section-field field-title="'Custom fields:'">
      <custom-field-definition-multiselect
        definition-ids="\$ctrl.accountProduct.productDefinition.customFieldDefinitionIds"
        group="'ACCOUNT'">
      </custom-field-definition-multiselect>
    </form-section-field>

  </form-section>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/advanced/deposit-account-advanced.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;